/**
 * Created by rlopez on 08/11/16.
 */

import $ from 'jquery';

import RestService from 'RestService.js';
import undoService from 'UndoService.js';
import eventBus from 'EventBus';
import NotificationService from 'NotificationService.js';
import textConstants    from 'TextConstants';
import constants    from 'Constants.js';
import util         from 'util/Util.js';
import listService from 'ListService.js';

const ICON_EMPTY = constants.DB_ICON_EMPTY;

//==========================================================================================
// This singleton controller handles resizing a control by dragging its borders.
//==========================================================================================
class UserController{

    constructor() {

    }

    createNew(mainView){
        return new Promise((resolve, reject) => {
          this.addUser(mainView).then((userId) => {
              undoService.add({
                  undo: () => {
                      this.deleteUser(userId);                      
                  },
                  redo: () => {
                    this.undeleteUser(mainView,userId);                   
                  }
              }, textConstants.UNDO_NEW_USER);
              util.setUndoRedoAccess();
              resolve(userId);
          }).catch(reject);
      });
    }

    deleteUser(userId){
        RestService.deleteUser(userId).then((response)=>{
            eventBus.trigger(constants.EV_DELETE_USER,userId);
        }).catch((err)=> {
            console.log('Error Deleting User', err);
            NotificationService.error('Error Deleting User' + err.MESSAGE);
        });
    }

    deleteUserGroup(userGroupId){
      RestService.deleteUserGroup(userGroupId).then((response)=>{
        eventBus.trigger(constants.EV_DELETE_USER_GROUP, userGroupId);
      }).catch((err)=> {
        console.log('Error Deleting User Group', err);
        NotificationService.error('Error Deleting User Group' + err.MESSAGE);
      });
    }

    deleteUserPosition(userPositionId){
      RestService.deletePosition(userPositionId).then((response)=>{
        eventBus.trigger(constants.EV_DELETE_USER_POSITION, userPositionId);
      }).catch((err)=> {
        console.log('Error Deleting User Position', err);
        NotificationService.error('Error Deleting User Position' + err.MESSAGE);
      });
    }

    addUser(mainView){
        return new Promise((resolve, reject) => {
           RestService.addUser().then((data)=>{
              const userId = data.RESULT.RESPONSE.UserId;
              this.expandUpdatedUserListAndDetailView(mainView,constants.USERS_GROUP_CONTAINER,constants.SETTINGS_USERS_GROUP_TYPE,userId);
              resolve(userId);
            },(err)=> {
              console.log('Error Creating User', err);
              if (err && typeof err === 'string') {
                reject(err);
            } else if (err && typeof err === 'object' && err.responseText) {
                const msg = JSON.parse(err.responseText);
                reject(`${msg.Message}. ${msg.ExceptionMessage}.`);
            } else {
                reject(err);
            }
          });
       });
    }

    undeleteUser(mainView,userId){
      return new Promise((resolve, reject) => {
         RestService.unDeleteUser(userId).then((data)=>{ 
          if (listService.activeDashboardTab === 'settings'){         
              this.expandUpdatedUserListAndDetailView(mainView,constants.USERS_GROUP_CONTAINER,constants.SETTINGS_USERS_GROUP_TYPE,userId);
          }
            resolve(userId);
          },(err)=> {
            console.log('Error Undeleting User', err);
            if (err && typeof err === 'string') {
              reject(err);
          } else if (err && typeof err === 'object' && err.responseText) {
              const msg = JSON.parse(err.responseText);
              reject(`${msg.Message}. ${msg.ExceptionMessage}.`);
          } else {
              reject(err);
          }
        });
     });
  }

    addUserGroup(mainView){
      return RestService.addUserGroup().then((data)=>{
        const userGroupId = data.GroupId;
        this.expandUpdatedUserGroupListAndDetailView(mainView,constants.USERS_GROUP_GROUP_CONTAINER,constants.SETTINGS_USERS_GROUP_TYPE,userGroupId);
        return userGroupId;
      }).catch((err)=> {
        console.log('Error Creating User Group', err);
        NotificationService.error(`Error Creating User Group. ${err.MESSAGE}`);
      });
    }

    undeleteUserGroup(mainView, userGroupId){
      return RestService.undeleteUserGroup(userGroupId).then((data)=>{
        if (listService.activeDashboardTab === 'settings'){         
          this.expandUpdatedUserGroupListAndDetailView(mainView,constants.USERS_GROUP_GROUP_CONTAINER,constants.SETTINGS_USERS_GROUP_TYPE,userGroupId);
        }
        return userGroupId;
      }).catch((err)=> {
        console.log('Error Creating User Group', err);
        NotificationService.error(`Error Creating User Group. ${err.MESSAGE}`);
      });
    }

    addUserPosition(mainView){
      return RestService.addPosition().then((data)=>{
        const positionId = data.PositionId;
        this.expandUpdatedUserPositionListAndDetailView(mainView,constants.USERS_POSITION_GROUP_CONTAINER,constants.SETTINGS_USERS_GROUP_TYPE,positionId);
        return positionId;
      }).catch((err)=> {
        console.log('Error Creating Position', err);
        NotificationService.error(`Error Creating Position. ${err.MESSAGE}`);
      });
    }

    undeleteUserPosition(mainView, positionId){
      return RestService.undeletePosition(positionId).then((data)=>{
        if (listService.activeDashboardTab === 'settings'){         
          this.expandUpdatedUserPositionListAndDetailView(mainView,constants.USERS_POSITION_GROUP_CONTAINER,constants.SETTINGS_USERS_GROUP_TYPE,positionId);
        }
        return positionId;
      }).catch((err)=> {
        console.log('Error Restoring Position', err);
        NotificationService.error(`Error Restoring Position. ${err.MESSAGE}`);
      });
    }



    createNewUserGroup(mainView){
      return this.addUserGroup(mainView).then((userGroupId) => {
        undoService.add({
          undo: () => {
            this.deleteUserGroup(userGroupId);
          },
          redo: () => {
            this.undeleteUserGroup(mainView, userGroupId);
          }
        }, textConstants.UNDO_NEW_USER_GROUP);
        util.setUndoRedoAccess();
        return userGroupId;
      });
    }

    createNewUserPosition(mainView){
      return this.addUserPosition(mainView).then((positionId) => {
        undoService.add({
          undo: () => {
            this.deleteUserPosition(positionId);
          },
          redo: () => {
            this.undeleteUserPosition(mainView, positionId);
          }
        }, textConstants.UNDO_NEW_USER_POSITION);
        util.setUndoRedoAccess();
         return positionId;
      });
    }

    expandUpdatedUserGroupListAndDetailView(mainView,dataTarget,groupType,userGroupId){
      RestService.browseUserGroups().then((data) => {
        let self=this;
        mainView.renderTreeNodes(data.Group,dataTarget,groupType,"GroupId","Name","userGroupDetail");
        $(constants.USERS_GROUP_GROUP_CONTAINER).collapse('show'); 
        self.showWorkingNode(userGroupId);
        mainView.renderGroupDetailsView(userGroupId);
      }).catch((error) => {
        console.log(error);

        var msg = error || 'Unknown Error';
        NotificationService.error(msg);
      });
    }

    expandUpdatedUserPositionListAndDetailView(mainView,dataTarget,groupType,positionId){
      RestService.browsePositions().then((data) => {
        let self=this;
        mainView.renderTreeNodes(data.Position,dataTarget,groupType,"PositionId","Name","userPositionDetail");
        $(constants.USERS_POSITION_GROUP_CONTAINER).collapse('show');        
          self.showWorkingNode(positionId);
        mainView.renderUserPositionDetailsView(positionId);
      }).catch((error) => {
        console.log(error);

        var msg = error || 'Unknown Error';
        NotificationService.error(msg);
      });
    }

    expandUpdatedUserListAndDetailView(mainView,dataTarget,groupType,userId){
      RestService.browseUsers().then((data) => {
          let self=this;
        mainView.renderTreeNodes(data.User,dataTarget,groupType,"UserId","Name","user");
        $(constants.USERS_GROUP_CONTAINER).collapse('show');
        this.showWorkingNode(userId);
         mainView.renderUserDetailsView(userId); 
      }).catch((error) => {
        console.log(error);

        var msg = error || 'Unknown Error';
        NotificationService.error(msg);
      });
    }



  showWorkingNode(userId){
    $('li[role="button"]').removeClass('bg-success');
    $(`i[data-itemid*="${userId}"]`).parent('li').addClass('bg-success');
  }


}

const userController = new UserController();
export default userController;
